export const passiveCollection: Record<number, { desc: (level: number) => string }> = {
  101: {
    desc: (level: number) => `每次<span class="info">普通攻击</span>恢复 <span class="grow">${1}</span><span class="mp">魔法值</span>`,
  },
  102: {
    desc: (level: number) => `<span class="info">暴击</span>时恢复 <span class="grow">${2}</span><span class="mp">魔法值</span>`,
  },
  103: {
    desc: (level: number) => `增加 <span class="grow">${1 + level * 0.5}</span><span class="mp">魔法回复速度</span>`,
  },
  104: {
    desc: (level: number) => `增加<span class="info">破防</span> <span class="grow">${1 + level * 0.5}%</span> 的 <span class="mp">魔法回复</span>`,
  },
}
